import InternalIndexBar from './index-bar';
import { Panel } from './panel';
export { IndexBarProps } from './index-bar';
export { IndexBarPanelProps } from './panel';
const IndexBar = InternalIndexBar;
IndexBar.Panel = Panel;
export default IndexBar;
